import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useState, useRef, useEffect, useCallback } from 'react';
import equal from 'fast-deep-equal';
import { useEffectOnce } from './use-effect-once.js';
import { useInterval } from './use-interval.js';
var updateIfChanged = function updateIfChanged(setState, newState) {
  var setOldState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
  var forceOldUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return setState(function (state) {
    if (setOldState) setOldState(state === null || forceOldUpdate ? newState : state);
    if (equal(state, newState)) return state;
    return newState;
  });
};
var updateFetcher = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(updateFunc, setState, setOldState, setLoading, signal) {
    var forceOldUpdate,
      data,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          forceOldUpdate = _args.length > 5 && _args[5] !== undefined ? _args[5] : false;
          if (updateFunc) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return Promise.resolve(updateFunc(signal));
        case 6:
          data = _context.sent;
          if (!(data === null)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", null);
        case 9:
          if (!signal.aborted) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", null);
        case 11:
          updateIfChanged(setState, data, setOldState, forceOldUpdate);
          if (setLoading) setLoading(false);
          return _context.abrupt("return", data);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](3);
          return _context.abrupt("return", null);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 16]]);
  }));
  return function updateFetcher(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var useUpdater = function useUpdater(initialData, updateFunc) {
  var updateInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var resetIfChanged = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    oldData = _useState4[0],
    setOldData = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var ref = useRef(updateFunc);
  var abortController = useRef(new AbortController());
  useEffect(function () {
    var controller = abortController.current;
    return function () {
      controller.abort();
    };
  }, []);
  var doUpdate = useCallback(function () {
    return updateFetcher(ref.current, setData, setOldData, setLoading, abortController.current.signal);
  }, [setData, setOldData, setLoading]);
  useEffect(function () {
    var isSame = ref.current === updateFunc;
    ref.current = updateFunc;
    if (!isSame) {
      if (resetIfChanged) setLoading(true);
      doUpdate();
    }
  }, [updateFunc, resetIfChanged, doUpdate]);
  useEffectOnce(function () {
    var fetchInitial = initialData !== void 0 && initialData !== null ? function () {
      return initialData;
    } : ref.current;
    var doInit = function doInit() {
      var breakOut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      updateFetcher(fetchInitial, setData, setOldData, setLoading, abortController.current.signal, true).then(function (result) {
        if (result === null && breakOut > 0) doInit(breakOut - 1);
      });
    };
    doInit();
  });
  useInterval(doUpdate, updateInterval);
  return [data, oldData, {
    loading: loading
  }];
};
export { useUpdater };